import {
    checkIn_checkedInEventFactory,
    checkIn_checkedInEventZodObject,
} from "@@/shared/statuses/reservation-check-ins/events/check-in.checked-in.event";
import {
    checkIn_checkedOutEventFactory,
    checkIn_checkedOutEventZodObject,
} from "@@/shared/statuses/reservation-check-ins/events/check-in.checked-out.event";
import {
    checkIn_initiatedEventFactory,
    checkIn_initiatedEventZodObject,
} from "@@/shared/statuses/reservation-check-ins/events/check-in.initiated.event";
import {
    checkIn_pendingEventFactory,
    checkIn_pendingEventZodObject,
} from "@@/shared/statuses/reservation-check-ins/events/check-in.pending.event";
import { z } from "zod";

const checkInEventZodUnion = z.union([
    checkIn_checkedInEventZodObject,
    checkIn_checkedOutEventZodObject,
    checkIn_initiatedEventZodObject,
    checkIn_pendingEventZodObject,
]);

type CheckInEvent = z.infer<typeof checkInEventZodUnion>;
type CheckInStatusType = CheckInEvent["type"];

const checkInStatusEventFactory = {
    checkedIn: checkIn_checkedInEventFactory,
    checkedOut: checkIn_checkedOutEventFactory,
    initiated: checkIn_initiatedEventFactory,
    pending: checkIn_pendingEventFactory,
};

export { checkInEventZodUnion, checkInStatusEventFactory };
export type { CheckInEvent, CheckInStatusType };
